import {
  ERROR,
  CONFIRM_AUTH_CODE,
  MARKETING_PREFERENCES,
  CONFIRM_CODE,
  ID_CHECK_CAN_NOT_DONE,
  JOINT_APPLICATION_SUBMISSION,
  SUBMISSION_HOLDING_SCREEN,
  GET_IN_TOUCH,
  NTB_DIP_DECLARATION_AND_AUTHORISATION,
  POST_DIP_REVIEW_DETAIL
} from 'constants/paths';
import {
  TASK_CREDIT_DECLINE,
  TASK_ACCOUNT_OPENED,
  TASK_ID_CHECK_CANT_DONE,
  TASK_PENDING_PRODUCT_DECISION,
  TASK_APPLICATION_CANCELLED,
  TASK_APPLICATION_EXPIRED,
  TASK_HOOYU_VERIFY_IDENTITY,
  RESUME_LOAN_TYPE,
  NTB_JOURNEY
} from 'constants/general';

import { nextRouteTask } from 'utils/getRoutePath';
import { navigateToScreen, redirectCustomerDetails } from 'actionCreators/navigation';
import { responseFailed } from 'actionCreators/error';
import { failedIdentityCheck, setMitekUrl } from 'actionCreators/case';

const nextTaskMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  if (action.type === 'case/getNextTaskSuccessResponse' && action.payload.TaskInfoGroup) {
    const state = store.getState();
    const {
      caseDetails,
      config: { journey, isJoint, jointLinkCode, isSecondaryApplicant, loanType },
      form: { ReviewLoanDetails }
    } = state;
    const {
      payload: {
        TaskInfoGroup: {
          action: { uri },
          id
        }
      }
    } = action;
    const { caseId } = caseDetails;
    const task = nextRouteTask(caseId, uri, id);

    let path = ERROR;

    if (task && task.routePath[journey]) {
      path = task.routePath[journey];
    }

    //show ID_CHECK_CAN_NOT_DONE screen if primary applicant resume or secondary applicant flow
    if (isJoint && task.id === TASK_ID_CHECK_CANT_DONE) {
      //set flag to show failed IDV content on joint application submission screen for primary applicant
      if (ReviewLoanDetails && !isSecondaryApplicant) {
        path = JOINT_APPLICATION_SUBMISSION;
        store.dispatch(failedIdentityCheck());
      } else if (
        (!ReviewLoanDetails && !isSecondaryApplicant) || // primary resume
        isSecondaryApplicant // secondary check
      ) {
        path = ID_CHECK_CAN_NOT_DONE;
      }
    }
    //show get in touch screen for secondary applicant having inflight case
    if (
      jointLinkCode &&
      !caseDetails.caseSubmitted &&
      task.id !== TASK_APPLICATION_CANCELLED &&
      task.id !== TASK_APPLICATION_EXPIRED &&
      task.id !== TASK_CREDIT_DECLINE &&
      task.id !== TASK_ACCOUNT_OPENED
    ) {
      path = GET_IN_TOUCH;
    }

    //if task received is pendproddec  and journey is joint and primary resume then redirect to submission holding screen
    if (
      isJoint &&
      task.id === TASK_PENDING_PRODUCT_DECISION &&
      ((!ReviewLoanDetails && !isSecondaryApplicant) || isSecondaryApplicant)
    ) {
      path = SUBMISSION_HOLDING_SCREEN;
    }

    if (task?.id === TASK_HOOYU_VERIFY_IDENTITY) {
      store.dispatch(setMitekUrl(task.mitekUrl));
    }

    if (path === ERROR) {
      store.dispatch(responseFailed);
    } else if (path === MARKETING_PREFERENCES) {
      store.dispatch(redirectCustomerDetails(MARKETING_PREFERENCES));
    } else if (path === CONFIRM_CODE && state.caseDetails.caseSubmitted) {
      store.dispatch(navigateToScreen(CONFIRM_AUTH_CODE));
    } else if (
      loanType === RESUME_LOAN_TYPE &&
      journey === NTB_JOURNEY &&
      path === NTB_DIP_DECLARATION_AND_AUTHORISATION &&
      !caseDetails?.dipSubmitAttempt
    ) {
      store.dispatch(navigateToScreen(POST_DIP_REVIEW_DETAIL));
    } else {
      store.dispatch(navigateToScreen(path));
    }
  }

  return result;
};

export { nextTaskMiddleware };
